module.exports = __webpack_public_path__ + "assets/img/logo.960e75d9.png";